import React from 'react';
import { Intro } from '@greystar/designsystem';
import { IntroductionProps, ResponsiveImage } from '@greystar/ui';
import { withDatasourceCheck, Text as JssText } from '@sitecore-jss/sitecore-jss-nextjs';

/**
 * A variant of the Introduction component that includes a sub-heading.
 *
 * This component renders an introduction section with images, heading, text and sub-heading.
 * It uses the `Intro` component from the design system to structure the layout.
 *
 * @param props - The properties for the IntroductionWithCallToAction component.
 * @param props.fields - The fields provided by the datasource.
 * @param props.fields.heading - The main heading text for the introduction.
 * @param props.fields.subHeading - The sub heading text for the introduction.
 * @param props.fields.image1 - The first image to display in the introduction.
 * @param props.fields.image2 - The second image to display in the introduction.
 *
 * @returns A JSX element rendering the introduction section with a call-to-action.
 */
export const Introduction = (props: IntroductionProps): JSX.Element => {
  const { heading, subHeading, image1, image2 } = props.fields;

  // Render fields
  const headingField = <JssText field={heading} />;
  const subHeadingField = <JssText field={subHeading} />;

  const renderImage1 = <ResponsiveImage image={image1} fill={true} />;
  const renderImage2 = <ResponsiveImage image={image2} fill={true} />;

  return (
    <Intro
      img1={renderImage1}
      img2={renderImage2}
      subheading={subHeadingField}
      heading={headingField}
    />
  );
};

export default withDatasourceCheck()<IntroductionProps>(Introduction);
